import React, { useState } from "react";
import "./pricing.css";

const PricingCard = () => {
  const [selectedCard, setSelectedCard] = useState(1);

  const handleCardSelect = (index) => {
    setSelectedCard(index);
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-4">
      {PricingData.map((element, index) => (
        <div
          key={index}
          onClick={() => handleCardSelect(index)}
          className={`pricing_card w-full p-5 rounded-xl cursor-pointer flex flex-col justify-between transition-all duration-300 ${
            selectedCard === index
              ? "border-2 border-t-zinc-200 border-r-gray-500 border-l-gray-500 border-b-gray-500"
              : "border border-gray-500"
          }`}
        >
          <div className="flex flex-col gap-4 mb-2">
            <h2 className="text-zinc-300 text-xl">{element.type}</h2>
            <h3 className="text-4xl">
              {element.cost}
              <span className="text-gray-400 text-xs">/month</span>
            </h3>
            <p className="text-zinc-300">{element.desc}</p>
            <button
              className={`py-2 rounded-lg text-white transition-colors ${
                selectedCard === index
                  ? "bg-gradient-to-r from-[#E10B7B] via-[#652D90] to-[#1C85C7]"
                  : "bg-[#2A2A2D]"
              }`}
            >
              {element.button}
            </button>
          </div>

          <div className="pricing_features flex flex-col justify-between gap-4 mt-4">
            <div className="flex justify-center items-center gap-2">
              <div className="w-24 border-t border-gray-700 h-0"></div>
              <h4 className="text-gray-400 text-sm">Features</h4>
              <div className="w-24 border-t border-gray-700 h-0"></div>
            </div>

            {[element.feature1, element.feature2, element.feature3, element.feature4, element.feature5].map(
              (feature, i) => (
                <div key={i} className="feature flex items-start gap-2">
                  <div className="w-6 p-1 flex rounded-full border-zinc-200 border">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="1rem"
                      height="1rem"
                      viewBox="0 0 24 24"
                    >
                      <rect width="24" height="24" fill="none" />
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        d="M20 7L10 17l-5-5"
                      />
                    </svg>
                  </div>
                  <span className="text-zinc-300">{feature}</span>
                </div>
              )
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PricingCard;


const PricingData = [
  {
    type: "Free",
    cost: "000",
    desc: "Great for trying out Finament and for tiny teams",
    button: "Start for Free",
    feature1: "Account Aggregation",
    feature2: "Expense Tracking",
    feature3: "Budgeting Tools",
    feature4: "Transaction Insights",
    feature5: "Basic Security",
  },
  {
    type: "Professional",
    cost: "9800",
    desc: "Best for growing startups and growing companies",
    button: "Sign Up with Professional",
    feature1: "Account Aggregation",
    feature2: "Expense Tracking",
    feature3: "Budgeting Tools",
    feature4: "Transaction Insights",
    feature5: "Basic Security",
  },
  {
    type: "Enterprise",
    cost: "16000",
    desc: "Best for large companies and teams requiring high security",
    button: "Sign Up with Enterprise",
    feature1: "Account Aggregation",
    feature2: "Expense Tracking",
    feature3: "Budgeting Tools",
    feature4: "Transaction Insights",
    feature5: "Basic Security",
  },
];
